module.exports = __webpack_public_path__ + "img/lqdownload.e7b5da67.svg";